module.exports = __webpack_public_path__ + "static/media/IMG_1145.0875ba85.jpg";